import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import type { ClipCoverImage } from '@/lib/cover/coverImage';
import {
  SAVE_CLIP_COVER,
  type SaveClipCoverMutation,
  type SaveClipCoverMutationVariables,
} from '@/queries/clipCover';

export type SaveCoverResult = { ok: true; coverUrl: string | null } | { ok: false };

export function useSaveClipCover() {
  const [mutate] = useMutation<SaveClipCoverMutation, SaveClipCoverMutationVariables>(SAVE_CLIP_COVER);
  const [saving, setSaving] = useState(false);

  const saveCover = useCallback(
    async (clipId: string, cover: ClipCoverImage | null): Promise<SaveCoverResult> => {
      setSaving(true);
      try {
        const { data, errors } = await mutate({
          variables: { id: clipId, data: { coverImage: cover } },
        });
        if (errors?.length || !data?.updateClipData) return { ok: false };
        return { ok: true, coverUrl: data.updateClipData.cover_image_url ?? null };
      } catch {
        return { ok: false };
      } finally {
        setSaving(false);
      }
    },
    [mutate],
  );

  return { saveCover, saving };
}
